<template>
  <div data-v-5fea6048="" data-v-2ac6a5fc="" class="addMethod">
    <!-- 主内容区：白色背景、圆角卡片，与首页容器风格统一 -->
    <div data-v-5fea6048="" class="content">
      <!-- 表单区域 -->
      <div data-v-5fea6048="" class="form-container">
        <!-- 银行名称选择 -->
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankName" class="form-label">银行名称</label>
          <div data-v-5fea6048="" class="form-input-group">
            <!-- 模拟下拉输入框外观 -->
            <input 
              data-v-5fea6048="" 
              v-model="bank" 
              readonly 
              type="text" 
              placeholder="请选择银行" 
              class="form-input"
            />
            <!-- 实际下拉选择器（视觉隐藏，仅保留功能） -->
            <select 
              data-v-5fea6048="" 
              id="bankName" 
              v-model="bank" 
              class="select-input"
              @change="syncBankInput"
            >
              <option data-v-5fea6048="" value="" disabled hidden>请选择银行</option>
              <option data-v-5fea6048="" v-for="(item, index) in banklist" :key="index" :value="item.bank_name">{{ item.bank_name }}</option>
            </select>
            <!-- 下拉箭头图标 -->
            <span data-v-5fea6048="" class="arrow-icon"><i class="fas fa-chevron-down"></i></span>
            <!-- 错误提示（默认隐藏） -->
            <div data-v-5fea6048="" class="error-message" style="display: none"></div>
          </div>
        </div>

        <!-- 银行卡号输入 -->
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankCardNo" class="form-label">银行卡号</label>
          <div data-v-5fea6048="" :class="['form-input-group', { 'input-error': isCardNoError }]">
            <input 
              data-v-5fea6048="" 
              id="bankCardNo" 
              maxlength="19" 
              v-model="bank_no" 
              type="text" 
              placeholder="请输入银行卡号" 
              class="form-input"
              @blur="checkCardNo"
            />
            <!-- 错误提示（根据验证结果显示） -->
            <div data-v-5fea6048="" class="error-message" :style="{ display: isCardNoError ? 'block' : 'none' }">
              请输入正确的银行卡号（8-19位数字）
            </div>
          </div>
        </div>

        <!-- 姓名输入 -->
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankOwner" class="form-label">姓名</label>
          <div data-v-5fea6048="" :class="['form-input-group', { 'input-error': isOwnerError }]">
            <input 
              data-v-5fea6048="" 
              id="bankOwner" 
              maxlength="80" 
              v-model="bank_owner" 
              type="text" 
              placeholder="请输入姓名" 
              class="form-input"
              @blur="checkOwner"
            />
            <div data-v-5fea6048="" class="error-message" :style="{ display: isOwnerError ? 'block' : 'none' }">
              请输入真实姓名
            </div>
          </div>
        </div>

        <!-- 开户网点输入 -->
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="bankBranchName" class="form-label">开户网点</label>
          <div data-v-5fea6048="" :class="['form-input-group', { 'input-error': isBranchError }]">
            <input 
              data-v-5fea6048="" 
              id="bankBranchName" 
              maxlength="80" 
              type="text" 
              v-model="bank_address" 
              placeholder="请输入开户网点（如：XX银行XX支行）" 
              class="form-input"
              @blur="checkBranch"
            />
            <div data-v-5fea6048="" class="error-message" :style="{ display: isBranchError ? 'block' : 'none' }">
              请输入完整的开户网点信息
            </div>
          </div>
        </div>

        <!-- 支付密码输入 -->
        <div data-v-5fea6048="" class="form-group">
          <label data-v-5fea6048="" for="payPassword" class="form-label">支付密码</label>
          <div data-v-5fea6048="" :class="['form-input-group', { 'input-error': isPayPassError }]">
            <input 
              data-v-5fea6048="" 
              id="payPassword" 
              maxlength="18" 
              type="password" 
              v-model="pay_pass" 
              placeholder="请输入支付密码" 
              class="form-input"
              @blur="checkPayPass"
            />
            <div data-v-5fea6048="" class="error-message" :style="{ display: isPayPassError ? 'block' : 'none' }">
              支付密码长度为6-18位
            </div>
          </div>
        </div>
      </div>

      <!-- 保存按钮 -->
      <div data-v-5fea6048="" class="button-wrapper">
        <button 
          data-v-5fea6048="" 
          class="submit-btn" 
          @click="bindCard"
          :disabled="isSubmitting"
        >
          <span v-if="!isSubmitting">保存</span>
          <span v-if="isSubmitting"><i class="fas fa-spinner fa-spin"></i> 提交中...</span>
        </button>
      </div>

      <!-- 客服提示 -->
      <p data-v-5fea6048="" class="add-error-tips">
        无法绑定？
        <span data-v-5fea6048="" @click="$parent.openKefu" class="contact-kefu">联系客服</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addBankCard',
  data() {
    return {
      baseURL: '',
      bank: '', // 银行名称（默认空，添加禁用选项）
      bank_owner: '', // 姓名
      pay_pass: '', // 支付密码
      bank_no: '', // 银行卡号
      bank_address: '', // 开户网点
      banklist: [], // 银行列表
      // 表单验证状态
      isCardNoError: false,
      isOwnerError: false,
      isBranchError: false,
      isPayPassError: false,
      // 提交状态（防止重复点击）
      isSubmitting: false
    };
  },
  created() {
    this.baseURL = sessionStorage.getItem('baseURL') || '';
    this.getBanklist();
  },
  methods: {
    // 获取银行列表
    getBanklist() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/banklist', {}).then(res => {
        this.$parent.hideLoading();
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
          return;
        }
        this.banklist = res.data;
      }).catch(() => {
        this.$parent.hideLoading();
        this.$parent.showTost(0, '获取银行列表失败，请重试');
      });
    },

    // 同步下拉选择值到输入框（解决select视觉问题）
    syncBankInput() {
      this.bank = this.bank; // 触发v-model更新，确保输入框显示选中值
    },

    // 表单验证：银行卡号
    checkCardNo() {
      const cardNoReg = /^\d{8,19}$/; // 8-19位数字
      this.isCardNoError = !cardNoReg.test(this.bank_no.trim());
    },

    // 表单验证：姓名
    checkOwner() {
      this.isOwnerError = this.bank_owner.trim() === '';
    },

    // 表单验证：开户网点
    checkBranch() {
      this.isBranchError = this.bank_address.trim() === '';
    },

    // 表单验证：支付密码
    checkPayPass() {
      this.isPayPassError = this.pay_pass.length < 6 || this.pay_pass.length > 18;
    },

    // 提交绑定银行卡
    bindCard() {
      // 先执行全量验证
      this.checkCardNo();
      this.checkOwner();
      this.checkBranch();
      this.checkPayPass();

      // 若存在验证错误，不提交
      if (this.isCardNoError || this.isOwnerError || this.isBranchError || this.isPayPassError || !this.bank) {
        this.$parent.showTost(0, '请完善并核对表单信息');
        return;
      }

      // 提交中状态锁定
      this.isSubmitting = true;
      this.$parent.showLoading();

      const info = {
        bank_owner: this.bank_owner.trim(),
        bank: this.bank,
        bank_address: this.bank_address.trim(),
        bank_no: this.bank_no.trim(),
        pay_pass: this.pay_pass
      };

      this.$apiFun.post('/api/bindcard', info).then(res => {
        this.$parent.hideLoading();
        this.isSubmitting = false;
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
          return;
        }
        // 绑定成功：提示+返回上一页
        this.$parent.showTost(1, '绑定成功');
        setTimeout(() => {
          this.$router.back();
        }, 1500);
      }).catch(() => {
        this.$parent.hideLoading();
        this.isSubmitting = false;
        this.$parent.showTost(0, '提交失败，请重试');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 引入首页基础样式变量，保持风格统一
$white: #ffffff;
$light-gray: #f9fafb;
$border-gray: #e5e7eb;
$accent: #165DFF; // 首页主题色
$error-red: #FF4D4F; // 错误提示色
$text-dark: #1f2937; // 深色文字
$text-gray: #4b5563; // 灰色文字
$transition: all 0.3s ease;
$radius: 8px; // 圆角（与首页按钮/卡片一致）

// 页面容器：白色背景、全屏布局
.addMethod {
  width: 100%;
  min-height: calc(100vh - 110px); // 减去顶部导航(50px)和底部导航(60px)高度
  background: $light-gray; // 页面背景色（与首页内容区一致）
  padding: 20px 16px;
  box-sizing: border-box;
}

// 表单卡片：白色背景、阴影，与首页游戏卡片/用户信息栏风格统一
.content {
  max-width: 500px; // 限制表单最大宽度，提升PC端体验
  margin: 0 auto;
  background: $white;
  border-radius: $radius;
  padding: 24px 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); // 轻微阴影，与首页一致
}

// 表单容器：统一内边距
.form-container {
  margin-bottom: 30px;
}

// 表单组：垂直间距
.form-group {
  margin-bottom: 20px;
}

// 表单标签：与首页表单标签风格统一
.form-label {
  display: block;
  font-size: 14px;
  color: $text-dark;
  margin-bottom: 6px;
  font-weight: 500;
}

// 表单输入组：包含输入框、图标、错误提示
.form-input-group {
  position: relative;
  width: 100%;

  // 错误状态样式
  &.input-error {
    .form-input {
      border-color: $error-red;
      &:focus {
        border-color: $error-red;
        box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
      }
    }
  }
}

// 表单输入框：白色背景、浅灰边框，与首页输入框风格统一
.form-input {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  padding-right: 36px; // 为下拉箭头预留空间
  background: $white;
  border: 1px solid $border-gray;
  border-radius: $radius;
  font-size: 14px;
  color: $text-dark;
  box-sizing: border-box;
  transition: $transition;

  // 聚焦状态：主题色边框，与首页按钮hover色一致
  &:focus {
    outline: none;
    border-color: $accent;
    box-shadow: 0 0 0 2px rgba(22, 93, 255, 0.2);
  }

  // 只读状态（银行选择框）
  &[readonly] {
    cursor: pointer;
    background: $light-gray;
    color: $text-gray;
  }

  // 占位符样式
  &::placeholder {
    color: #9ca3af;
    font-size: 13px;
  }
}

// 下拉选择器：视觉隐藏，仅保留功能（用input模拟外观）
.select-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0; // 隐藏原生select
  cursor: pointer;
  z-index: 1; // 确保点击能触发选择
}

// 下拉箭头图标：与输入框对齐
.arrow-icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 12px;
  z-index: 0;
}

// 错误提示：红色文字，与输入框底部对齐
.error-message {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  font-size: 12px;
  color: $error-red;
  line-height: 1.4;
}

// 提交按钮：主题色背景，与首页充值/提现按钮风格统一
.submit-btn {
  width: 100%;
  height: 46px;
  background: $accent;
  color: $white;
  border: none;
  border-radius: $radius;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: $transition;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  // 禁用/加载状态
  &:disabled {
    background: #84A9FF;
    cursor: not-allowed;
    transform: none;
  }

  // hover效果，与首页按钮一致
  &:not(:disabled):hover {
    background: #0E42C3;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(22, 93, 255, 0.2);
  }
}

// 按钮容器：统一间距
.button-wrapper {
  margin-bottom: 20px;
}

// 客服提示文字：灰色文字，客服链接用主题色
.add-error-tips {
  margin: 0;
  text-align: center;
  font-size: 13px;
  color: $text-gray;
  line-height: 1.6;

  .contact-kefu {
    color: $accent;
    cursor: pointer;
    font-weight: 500;
    &:hover {
      text-decoration: underline;
    }
  }
}

// 移动端适配：优化小屏显示
@media (max-width: 375px) {
  .content {
    padding: 20px 14px;
  }

  .form-input {
    height: 42px;
  }

  .submit-btn {
    height: 44px;
    font-size: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/main/addBankCard.vue